import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { getBetupMatchIdByVirtualSyncId } from '../../Api';

/**
 * Opens a virtual match's BetUp page from the provider's sync id.
 *
 * Match lists are paginated straight from the provider, so rows only carry provider ids. The BetUp
 * id is resolved on demand, at click time, instead of being carried through every list.
 */
export function useOpenVirtualMatch() {
    const navigate = useNavigate();
    const [openingSyncId, setOpeningSyncId] = React.useState<string | null>(null);
    const [error, setError] = React.useState('');

    const openMatch = React.useCallback(async (syncId: string) => {
        setOpeningSyncId(syncId);
        setError('');
        try {
            const betupId = await getBetupMatchIdByVirtualSyncId(syncId);
            if (betupId == null) {
                setError('This match has not been replicated to BetUp yet.');
                return;
            }
            navigate(`/matches/${betupId}`);
        } finally {
            setOpeningSyncId(null);
        }
    }, [navigate]);

    return { openMatch, openingSyncId, error, clearError: () => setError('') };
}
